import React from 'react';

import { Autocomplete, TextField } from '@mui/material';
import { JoinCondition } from '@models/feature-descriptor';
import { Unset } from '@utils';

export const JoinConditionSelectionType = (props: {
  types?: JoinCondition.Type[];
  value: JoinCondition.Type | Unset;
  onValueChange: (type: JoinCondition.Type) => void;
  onBlur?: () => void;
}) => {
  return (
    <Autocomplete
      style={{ width: '150px' }}
      options={props.types ?? Object.values(JoinCondition.Type)}
      value={props.value!}
      size="small"
      autoComplete
      disableClearable
      blurOnSelect
      openOnFocus
      forcePopupIcon={false}
      onBlur={props.onBlur}
      onChange={(e, value) => value && props.onValueChange(value)}
      renderInput={params => (
        <TextField {...params} variant="standard" autoFocus={true} />
      )}
    />
  );
};
